// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1f0mt","buttons":"RemoveExpirationActionButtons_buttons__3XqC2"};